import { createReducer, on } from '@ngrx/store';
import {
    AVAILABILITY_FIND_ALL_SUCCESS,
    AVAILABILITY_FAILED,
    AVAILABILITY_UPDATE_LOADING,
    AVAILABILITY_FIND_SUCCESS
} from '../actions';
import { Availability } from '@core/models';

export interface AvailabilityState {
  availabilityList: Availability[];
  availabilityId: string | null;
  error: string | null;
  loading: boolean;
  availability: Availability | null;
}

const initialState: AvailabilityState = {
  availability: null,
  availabilityList: [],
  availabilityId: null,
  error: null,
  loading: false,
};

export const availabilityReducer = createReducer(
  initialState,
  on(AVAILABILITY_FIND_SUCCESS, (state, { availability }) => ({ ...state, availability })),
  on(AVAILABILITY_FIND_ALL_SUCCESS, (state, { availabilityList }) => ({ ...state, availabilityList })),
  on(AVAILABILITY_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(AVAILABILITY_FAILED, (state, { error }) => ({ ...state, error })),
);
